export const getPhoneErrorText = (
	showValidationErrors: boolean,
	phoneRequiredFromSplit: boolean,
	phone: string,
) => {
	if (!showValidationErrors) return '';

	const isPhoneInvalid = phone.length > 0 && phone.length < 14;

	if (phoneRequiredFromSplit) {
		if (!phone) return 'Phone number is required';
		if (isPhoneInvalid) return 'A valid, 10-digit phone number is required';
	} else if (isPhoneInvalid) {
		return 'If provided, a valid, 10-digit phone number is required';
	}

	return '';
};
